/**
 * Constantes pour les actions et messages du jeu
 * Facilite la compréhension et la maintenance
 */

export const GAME_ACTIONS = {
  BALL: 'ball',
  MESSAGE: 'message',
  MESSAGE_PERSONNALISE: 'messagePersonnalise',
  WINNER: 'winner',
  UPDATE_WINNER: 'updateWinner',
};

export const GAME_MESSAGES = {
  GAME_ENDED: 'Message01',
  BINGO_POSSIBILITY: 'Message02',
  JOKER_BALL: 'Message03',
  UPDATE_CARD: 'Message03a',
  GAME_STARTS_AGAIN: 'Message04',
  HALF_AND_HALF: 'Message05',
  TRANSCRIPTION_ERROR: 'Message06',
};

/**
 * Messages qui nécessitent un fetchModel complet
 * (fin de partie, erreur de transcription, reconnexion)
 */
export const MESSAGES_REQUIRING_FULL_REFRESH = [
  GAME_MESSAGES.GAME_ENDED,
  GAME_MESSAGES.TRANSCRIPTION_ERROR,
];

/**
 * Messages qui nécessitent seulement une mise à jour incrémentale
 * (boule tirée, gagnant, message personnalisé)
 */
export const MESSAGES_REQUIRING_INCREMENTAL_UPDATE = [
  GAME_ACTIONS.BALL,
  GAME_ACTIONS.WINNER,
  GAME_ACTIONS.MESSAGE_PERSONNALISE,
];

